import React, { useMemo } from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const SnackbarComponent = ({ open, response, onClose }) => {
  const determineSeverity = useMemo(() => {
    return response && response.status === 200 ? "success" : "error";
  }, [response]);

  const determineMessage = useMemo(() => {
    if (response && response.message) {
      return response.message;
    } else {
      return "An error occurred";
    }
  }, [response]);

  return (
    <Snackbar open={open} autoHideDuration={2000} onClose={onClose}>
      <MuiAlert
        elevation={6}
        variant="filled"
        severity={determineSeverity}
        onClose={onClose}
      >
        {determineMessage}
      </MuiAlert>
    </Snackbar>
  );
};

export default SnackbarComponent;
